/**
 * Actions that can be performed on a cart.
 */
export enum CheckoutAction {
    // Validate the cart and update the cart lines
    VALIDATE = 'CHECK',
    // Checkout the cart and create an order
    CHECKOUT = 'CHECKOUT'
}